/**
 * Maps stored capability roles to the admin-route / nav "gating" role they inherit.
 * Keeps route and menu config on coarse roles (e.g. super_admin) while DB may store *_team_member.
 */
const ROLE_EQUIVALENTS_FOR_GATING: Record<string, string> = {
  super_team_member: "super_admin",
  super_admin_team_member: "super_admin",
  partner_team_member: "partner_admin",
  company_team_member: "team_member",
};

export function normalizeRoleForGating(role: string): string {
  const key = (role || "").toLowerCase();
  return ROLE_EQUIVALENTS_FOR_GATING[key] || key;
}

/** Legacy UI/API spellings and compact forms → underscore keys before applying ROLE_EQUIVALENTS_FOR_GATING. */
function toComparableRoleKey(role: string): string {
  const raw = (role || "").trim();
  if (!raw) return "";
  let r = raw.toLowerCase().replace(/-/g, "_");
  const compact = r.replace(/_/g, "");
  if (compact === "superadmin") return "super_admin";
  if (compact === "superteammember") return "super_team_member";
  if (compact === "partneradmin") return "partner_admin";
  if (compact === "partnerteammember") return "partner_team_member";
  return r;
}

/** True for super_admin and super-side team / legacy variants (single source for admin UI checks). */
export function isSuperAdminRole(role: string | null | undefined): boolean {
  const key = toComparableRoleKey(role ?? "");
  if (!key) return false;
  return normalizeRoleForGating(key) === "super_admin";
}

/** True for partner_admin and partner_team_member (+ legacy spellings). */
export function isPartnerAdminRole(role: string | null | undefined): boolean {
  const key = toComparableRoleKey(role ?? "");
  if (!key) return false;
  return normalizeRoleForGating(key) === "partner_admin";
}

/** Super admin / partner staff (and team equivalents) may use the Admin dashboard. */
export function isAdminDashboardRole(role: string | null | undefined): boolean {
  return isSuperAdminRole(role) || isPartnerAdminRole(role);
}

export const ADMIN_REQUIRES_COMPANY_PORTAL_MESSAGE =
  "Company accounts must sign in at the company portal, not the admin dashboard.";
